import React, { useRef } from "react";

import { withWoosMap } from "@services/woosmap/woosmap.initializer";

import { Messages } from "@components/General/Messages/messages.container";

import { useMap } from "./hooks/useMap.hook";
import { StoreDirectionsComponent } from "./storeDirections.component";
import { STORE_DIRECTIONS_MESSAGE_ID } from "./storeDirections.config";
import { StoreDirectionsContextProvider } from "./storeDirections.context";
import { StoreDirectionsSkeleton } from "./storeDirections.skeleton";

export type StoreDirectionsProps = {
    latitude: number;
    longitude: number;
    storeName: string;
};

const _StoreDirections = ({
    latitude,
    longitude,
    storeName,
}: StoreDirectionsProps) => {
    const mapElementRef = useRef<HTMLDivElement>(null);

    const destination: woosmap.map.LatLngLiteral = {
        lat: latitude,
        lng: longitude,
    };

    useMap(mapElementRef, destination);

    return (
        <StoreDirectionsContextProvider
            storeName={storeName}
            mapElementRef={mapElementRef}
            destination={destination}
        >
            <Messages messageid={STORE_DIRECTIONS_MESSAGE_ID} />
            <StoreDirectionsComponent mapElementRef={mapElementRef} />
        </StoreDirectionsContextProvider>
    );
};

export const StoreDirections = withWoosMap(
    _StoreDirections,
    StoreDirectionsSkeleton,
);
